/**
 *
 * ParrotSoftware
 * GoogleMapsProvider root
 *
 */
import { Children, memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function GoogleMapsProvider({ children }) {
  useInjectSaga({ key: 'googleMapsProvider', saga });
  useInjectReducer({ key: 'googleMapsProvider', reducer });

  return Children.only(children);
}

GoogleMapsProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withGoogleMaps } from './withGoogleMaps';
export default compose(withConnect, memo)(GoogleMapsProvider);
